import type { FC } from "react";

import { useRestoreScrollOnBack } from "@shared/hooks";
import { Route, Routes } from "@shared/react-router-dom";
import { wildcardPath } from "@shared/utils";
import { authRoutes } from "@unauthenticated/shared/data/authRoutes";
import type { PractitionerType } from "@unauthenticated/shared/data/types";
import { LazyEditPasswordPage } from "@unauthenticated/signupSignin/scenes/EditPasswordPage";
import { LazyForgotPasswordPage } from "@unauthenticated/signupSignin/scenes/ForgotPasswordPage";
import { PatientSignUpPage } from "@unauthenticated/signupSignin/scenes/PatientSignUpPage";
import { PractitionerSignUpPage } from "@unauthenticated/signupSignin/scenes/PractitionerSignUpPage";
import { LazySignInPage } from "@unauthenticated/signupSignin/scenes/SignInPage";

interface Props {
  practitionerTypes: PractitionerType[];
  signUpAdditionalAttributes?: any;
  signInAdditionalAttributes?: any;
  csuid: string;
  newSSOErrors?: string;
  authErrors?: string;
  pageVersion: "prac_by_default_with_sso" | "prac_by_default";
}

const Pages: FC<Props> = ({
  practitionerTypes,
  signUpAdditionalAttributes,
  signInAdditionalAttributes,
  csuid,
  newSSOErrors,
  authErrors,
  pageVersion,
}) => {
  useRestoreScrollOnBack();

  return (
    <Routes>
      <Route path={wildcardPath(authRoutes.edit_password)} element={<LazyEditPasswordPage />} />
      <Route path={wildcardPath(authRoutes.forgot_password)} element={<LazyForgotPasswordPage />} />
      <Route
        path={wildcardPath(authRoutes.login)}
        element={
          <LazySignInPage
            newSSOErrors={newSSOErrors}
            authErrors={authErrors}
            additionalAttributes={signInAdditionalAttributes}
          />
        }
      />
      <Route
        path={wildcardPath(authRoutes.patient_sign_up)}
        element={<PatientSignUpPage csuid={csuid} pageVersion={pageVersion} />}
      />
      <Route
        path={wildcardPath(authRoutes.practitioner_sign_up)}
        element={
          <PractitionerSignUpPage
            practitionerTypes={practitionerTypes}
            additionalAttributes={signUpAdditionalAttributes}
            csuid={csuid}
            pageVersion={pageVersion}
          />
        }
      />
      <Route
        path={wildcardPath(authRoutes.wellevate_practitioner_sign_up)}
        element={
          <PractitionerSignUpPage
            practitionerTypes={practitionerTypes}
            additionalAttributes={signUpAdditionalAttributes}
            csuid={csuid}
            pageVersion={pageVersion}
          />
        }
      />
      <Route
        path={wildcardPath(authRoutes.emerson_ecologics_practitioner_sign_up)}
        element={
          <PractitionerSignUpPage
            practitionerTypes={practitionerTypes}
            additionalAttributes={signUpAdditionalAttributes}
            csuid={csuid}
            pageVersion={pageVersion}
          />
        }
      />
    </Routes>
  );
};

export { Pages };
